import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FormFeedback from './FormFeedback';

function WrappedFormSelect(props) {
  return (
    <React.Fragment>
      <Select
        {...props}
        value={props.input.value}
        onChange={option => props.input.onChange(option ? option.value : 'other')}
        onBlur={() => props.input.onBlur(props.input.value)}
        // onFocus={() => props.meta.select()}
        options={props.options}
      />

      {props.meta.dirty && props.input.value === '' && (
        <FormFeedback positive={false}>
          This field is required.
        </FormFeedback>
      )}
    </React.Fragment>
  );
}

WrappedFormSelect.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool
  }).isRequired,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string
      }),
      PropTypes.any
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ).isRequired
};

export default WrappedFormSelect;



// WEBPACK FOOTER //
// ./src/components/form/WrappedFormSelect.js